import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { widgetService } from "../services/widgetService";
import {
  dateFieldOptionsFromMapping,
  type IndexDateFieldOption,
} from "../utils/mappingDateFields";

export function useIndexDateFieldOptions(index: string) {
  const { t } = useTranslation();
  const [options, setOptions] = useState<IndexDateFieldOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    const trimmed = index.trim();
    if (!trimmed) {
      setOptions([]);
      setError(null);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await widgetService.getMappingHints(trimmed);
      setOptions(dateFieldOptionsFromMapping(response.fields));
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : String(e);
      if (/not allowed|not approved|FORBIDDEN|403/i.test(message)) {
        setError(t("widget.indexNotAllowed"));
      } else {
        setError(message || t("visualEditor.hintsLoadFailed"));
      }
      setOptions([]);
    } finally {
      setLoading(false);
    }
  }, [index, t]);

  useEffect(() => {
    load().catch(console.error);
  }, [load]);

  return { options, loading, error, reload: load };
}
